import request from '@/utils/request';
import constants from '@/utils/constants';

const autocompleteService = {
  getList({ url, searchString, requestParams }) {
    const requestConfig = {
      url,
      method: 'get',
      params: {
        search: searchString,
        maxResults: constants.API.AUTOCOMPLETE.LIMIT
      }
    };
    requestConfig.params = Object.assign(requestConfig.params, requestParams || {});

    // If caller explicitly provided includeInactive (true/false), forward it
    // as-is so the final request URL contains that query param. Some callers
    // pass `includeInactive` explicitly and expect the backend to receive it.
    if (requestParams && Object.prototype.hasOwnProperty.call(requestParams, 'includeInactive')) {
      requestConfig.params.includeInactive = requestParams.includeInactive;
    }

    return request(requestConfig);
  }
};
export default autocompleteService;
